import { render, staticRenderFns } from "./_PopDetail.vue?vue&type=template&id=5dc3e34d&scoped=true"
import script from "./_PopDetail.vue?vue&type=script&lang=ts"
export * from "./_PopDetail.vue?vue&type=script&lang=ts"
import style0 from "./_PopDetail.vue?vue&type=style&index=0&id=5dc3e34d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc3e34d",
  null
  
)

export default component.exports